
<table class="table">
  <thead class="">
    <tr>
      <th style="max-width: 35px;"></th>
      <th>Order</th>
      @if (ShowFullDetail()) {
        <th>Date</th>
      }
      <th>status</th>
      <th>Total</th>
      <th>Details</th>
    </tr>
  </thead>
  @for (order of orders; track order; let i = $index) {
    <tbody class="table-body cell-1 ">
      <tr>
        <td style="max-width: 35px;">
          <button (click)="setOrderDetailsVisible(!ordersCollapsed[i], i)" style="background-color: transparent; border: none;">
            @if (ordersCollapsed[i]) {
              <div>
                <svg width="35px" height="35px"><image loading="lazy" href="assets/assets_web_2/angle-right-rounded.svg" alt="Icon" width="30px" height="30px" /></svg>
              </div>
            }
            @if (!ordersCollapsed[i]) {
              <div>
                <svg width="35px" height="35px"><image loading="lazy" href="assets/assets_web_2/angle-bottom-rounded.svg" alt="Icon" width="30px" height="30px" /></svg>
              </div>
            }
          </button>
        </td>
        <td>{{order.id}}</td>
        @if (ShowFullDetail()) {
          <td>{{order.order_date | date :'short'}}</td>
        }
        <td><div class="d-flex justify-content-center align-items-center"><span class="badge" [ngClass]="{'bg-success': orderStatusToString(order.status)==='SHIPPED', 'bg-info': orderStatusToString(order.status)==='CREATED' }">{{orderStatusToString(order.status)}}</span></div></td>
        <td><div class="d-flex justify-content-center align-items-center">{{orderPrice(order)}} EUR</div></td>
        <td>
          <div class="d-flex align-items-center">
            <div class="flex-fill">
              {{ordersProductsToString(order)}}
            </div>
          </div>
        </td>
      </tr>
      @if (!ordersCollapsed[i]) {
        <tr class="colapsedOrder" style="max-width: fit-content;">
          <td colspan="6">
            <div class="row">
              @for (product of order.products; track product) {
                <div class="col p-2">
                  <div class="d-flex align-items-center">
                    <svg height="66px" width="66px">
                      <rect id="Rectangle_60" loading="lazy" alt="Icon" width="10px" height="10px" transform="translate(15 33) rotate(-45)" />
                    </svg>
                    <span style="color: white;">
                      {{product.quantity}}
                    </span>
                    <button (click)="goToProductDescription(product)" style="background-color: transparent; border: none;">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="d-flex flex-column" style="gap:5px">
                          <img loading="lazy" src="{{getImage(product.product)}}" alt="avatar" class="img-fluid" style="width: min(200px,80vw); height: auto">
                          <span style="white-space: nowrap; color: white;">
                            {{product.product.name}}
                          </span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  }
</table>
